var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCampaign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M74 65.556a.556.556 0 0 0-.556-.556H7.294a.294.294 0 0 0-.294.294A4.706 4.706 0 0 0 11.706 70h57.85A4.444 4.444 0 0 0 74 65.556ZM10 61V26a3 3 0 0 1 3-3h20m37 38V26a3 3 0 0 0-3-3H47"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M40 45v6M33 49v3M47 49v3M62.96 62s-.992-3.758-2.96-4.5c-1.89-.713-4 1.5-4 1.5s-1.555-2.401-4.522-3C49 55.5 47 58 47 58s-2-3.472-6-4c-3.785-.5-7 4-7 4s-2.866-2.462-5-2c-1.945.42-4 3.5-4 3.5s-2.5-3.74-5.464-2.41C16.249 58.567 17.04 62 17.04 62M44 49h8v-5.55a6 6 0 0 0-1.474-3.938L47 35.46V19.004a4 4 0 0 0-.641-2.173l-4.68-7.234a2 2 0 0 0-3.358 0l-4.68 7.234A4 4 0 0 0 33 19.004V35.46l-3.526 4.052A6 6 0 0 0 28 43.451V49h8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66 60V27H50M14 60V27h16"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 27,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 36H14M24 45H14M24 54H14M29 33H14M24 42H14M24 51H14M29 30H14M24 39H14M24 48H14M53 36h13M56 45h10M56 54h10M51 33h15M56 42h10M56 51h10M51 30h15M56 39h10M56 48h10"
}))));
export default SvgCampaign;